import { SearchResults } from "../../Shared/scriptts/interfaces";
import { params, executeSearchUrl, brandedSearch, displayResults } from '../search-main';
import { addToArrayParam, removeFromArrayParam } from '../search-filters-main';
import { URLCriteriaHelper } from '../search-urlcriteriahelper';

declare var series: any;

let showNoCountSeries = false;
let noCountSeries: HTMLLIElement[] = [];
let foundSeries: HTMLLIElement[] = [];
let seriesGroups: HTMLLIElement[] = [];

const countIcon = document.createElement('span');

document.addEventListener('DOMContentLoaded', () => {
    document.querySelector<HTMLInputElement>('#series-search')?.addEventListener('keyup', seriesSearchKeyup);
    document.querySelector<HTMLButtonElement>('#filter-series-showall-toggle')?.addEventListener('click', showAllToggleClicked);
});

export function displaySeriesFilter(data: SearchResults) {
    buildSeriesFilter(data);
    const titleElem = document.querySelector<HTMLElement>('#titleaccordion-series');
    if (titleElem !== null) {
        countIcon.className = params.JobCategoryCode?.length > 0 ? 'bg-warning rounded-full py-1 px-2 ml-2' : 'bg-warning rounded-full py-1 px-2 ml-2 hidden';
        countIcon.innerText = params.JobCategoryCode?.length.toString();
        if (!titleElem.contains(countIcon)) {
            titleElem.appendChild(countIcon);
        }
    }
}

function buildSeriesFilter(data: SearchResults, searchText: string = '') {
    const seriesContainer = document.querySelector<HTMLUListElement>('#filter-series-list');
    if (seriesContainer === null) {
        return;
    }
    const isSearch = searchText.length > 2;
    const brandedSearchSeries = !brandedSearch ? null : brandedSearch.JobCategoryCode;
    const isFilterSelectable = !brandedSearchSeries || brandedSearchSeries.length == 0;
    let jobCodes: string[] = [];
    for (const s in series) {
        jobCodes.push(s);
    }
    jobCodes.sort();
    seriesContainer.innerHTML = '';
    if (!isFilterSelectable) {
        document.querySelector<HTMLElement>('#series-search-container')?.classList.add('hidden');
        document.querySelector<HTMLElement>('#filter-series-showall-toggle')?.classList.add('hidden');
        document.querySelector<HTMLElement>('#filter-series-showall-toggle')?.classList.add('md:hidden');
    }

    jobCodes.forEach(jobCode => {
        const groupLI = document.createElement('li');
        const groupUL = document.createElement('ul');
        let seriesJobCount = 0;

        groupLI.innerHTML = `<h4 class="mt-4 border-b border-gray-lighter text-primary-darker text-lg${isSearch || !isFilterSelectable ? ' hidden' : ''}">${series[jobCode].Name}</h4>`;
        groupUL.className = 'space-y-1';

        for (const seriesCode in series[jobCode].Children) {
            if (!isFilterSelectable && brandedSearchSeries.indexOf(seriesCode) === -1) {
                continue;
            }
            const count: string = (data['f']['j'][seriesCode] ?? '0').toString();
            const li = document.createElement('li');
            const input = document.createElement('input');
            const label = document.createElement('label');
            const checked = params.JobCategoryCode?.indexOf(seriesCode) > -1;

            input.type = 'checkbox';
            input.name = 'occupation_series';
            input.value = seriesCode;
            input.id = `series-id-${seriesCode}`;
            input.checked = checked;
            input.addEventListener('change', seriesChanged);
            input.disabled = !isFilterSelectable;

            label.innerHTML = `${series[jobCode].Children[seriesCode].Name} <span class="text-gray text-sm">(${count})</span>`;
            label.setAttribute('for', input.id);

            li.id = `series-li-${seriesCode}`;
            li.setAttribute('data-count', count);
            li.appendChild(input);
            li.appendChild(label);

            if (count === '0' && !showNoCountSeries) {
                noCountSeries.push(li);
                if (showNoCountSeries === false) {
                    li.classList.add('hidden');
                }
            }
            else {
                ++seriesJobCount;
            }

            groupUL.appendChild(li);
        }

        groupLI.appendChild(groupUL);

        if (seriesJobCount < 1) {
            groupLI.classList.add('hidden');
        }

        seriesContainer.appendChild(groupLI);
        seriesGroups.push(groupLI);
    });
}

function setSeriesFilterDisplay() {
    const searchLength = document.querySelector<HTMLInputElement>('#series-search')?.value.length ?? 0;
    document.querySelector<HTMLUListElement>('#filter-series-list')?.querySelectorAll<HTMLLIElement>('li').forEach(li => {
        const found = foundSeries.indexOf(li) > -1;
        const inNoCountList = noCountSeries.indexOf(li) > -1;

        if (li.querySelector<HTMLInputElement>('input')?.checked || (inNoCountList && showNoCountSeries && (searchLength < 3 || found)) || (!inNoCountList && (searchLength < 3 || found))) {
            li.classList.remove('hidden');
        }
        else {
            li.classList.add('hidden');
        }
    });

    seriesGroups.forEach(groupList => {
        let showGroup = false;

        if (searchLength > 2) {
            groupList.querySelector('h4')?.classList.add('hidden');
        }
        else {
            groupList.querySelector('h4')?.classList.remove('hidden');
        }

        groupList.querySelectorAll<HTMLLIElement>('li').forEach(li => {
            if (!li.classList.contains('hidden')) {
                showGroup = true;
            }
        });

        if (showGroup) {
            groupList.classList.remove('hidden');
        }
        else {
            groupList.classList.add('hidden');
        }
    });
}

function seriesChanged(evt: Event) {
    const seriesInput = <HTMLInputElement>(evt.target);
    if (seriesInput.checked) {
        addToArrayParam('JobCategoryCode', seriesInput.value);
    }
    else {
        removeFromArrayParam('JobCategoryCode', seriesInput.value);
    }
    if (params.JobCategoryCode.length > 0) {
        countIcon.innerText = params.JobCategoryCode.length.toString();
        countIcon.classList.remove('hidden');
    }
    else {
        countIcon.innerText = '0';
        countIcon.classList.add('hidden');
    }

    displayResults(executeSearchUrl, false, true);
    URLCriteriaHelper.reconstructUrl();
}

function seriesSearchKeyup(evt: Event) {
    const searchInput = <HTMLInputElement>(evt.target);
    foundSeries = [];
    document.querySelector<HTMLUListElement>('#filter-series-list')?.querySelectorAll('li').forEach(li => {
        const seriesCode = li.id.substring(li.id.lastIndexOf('-') + 1);
        const seriesGroup = `${seriesCode.substring(0, 2)}00`;
        const seriesInput = document.querySelector<HTMLInputElement>(`#series-id-${seriesCode}`);

        if (seriesInput === null) {
            return;
        }
        if (searchInput.value.length < 3) {
            document.querySelector<HTMLButtonElement>('#filter-series-showall-toggle')?.classList.remove('md:hidden');
        }
        else {
            const found = series[seriesGroup]?.Children[seriesCode]?.Name.toLowerCase().includes(searchInput.value.toLowerCase());
            if (found === true) {
                foundSeries.push(li);
            }
        }
    });

    setSeriesFilterDisplay();
}

function showAllToggleClicked() {
    const toggleButton = document.querySelector<HTMLButtonElement>('#filter-series-showall-toggle');
    if (toggleButton === null) {
        return;
    }

    showNoCountSeries = !showNoCountSeries;
    toggleButton.innerText = showNoCountSeries ? 'Hide options with 0 jobs' : 'Show options with 0 jobs';
    setSeriesFilterDisplay();
}
